module.exports = __webpack_public_path__ + "static/media/omdb-movies-combined-iphonex.4240d377.png";